import { t } from "i18next";
import GridDateFormatCell from "../../../components/GridCell/GridDateFormatCell";

export const eventDateGridColumns = [
  {
    field: "baslik",
    title_key: "header",
    width: "200px",
  },
  {
    field: "baS_TAR",
    title_key: "start_date",
    width: "250px",
    cell: (props) => GridDateFormatCell(props, t("date_formats.shortDateTime")),
  },
  {
    field: "biT_TAR",
    title_key: "end_date",
    width: "250px",
    cell: (props) => GridDateFormatCell(props, t("date_formats.shortDateTime")),
  },
];
